import Icon from '@components/tailwind/Icon';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

type TUltraLightCollectionFeature = {
  title: string;
  description: string;
  icon: string;
};

const ultraLightCollectionFeatures: TUltraLightCollectionFeature[] = [
  {
    icon: require('@features/pdp/images/ultra-light-construction.svg'),
    title: 'Up to 30% Lighter',
    description: 'Engineered to be up to 30% lighter than rotomolded coolers.',
  },
  {
    icon: require('@features/pdp/images/52qt-ultralight-wheeled/icon-ice-retention.svg'),
    title: 'Ice Retention',
    description: 'Enjoy multi-day ice retention that keeps your drinks and food cold.',
  },
  {
    icon: require('@features/pdp/images/52qt-ultralight-wheeled/icon-durability.svg'),
    title: 'RTIC Tough',
    description: 'A premium cooler designed to last through years of fun and adventure.',
  },
];

type TProps = {
  className?: string;
  smallPrint?: ReactNode;
};

const UltraLightCollectionFeatures = ({ className = '', smallPrint }: TProps) => {
  return (
    <div className={classNames('tw-px-5 tw-pb-8 tw-pt-8', className)}>
      <p className='tw-mb-7 tw-text-center tw-text-2xl tw-font-bold tw-text-body'>
        ULTRA-LIGHT COLLECTION FEATURES
      </p>

      <div className='tw-mx-auto tw-flex tw-w-full tw-flex-wrap tw-justify-center tw-gap-8 md:tw-flex-nowrap md:tw-gap-[70px]'>
        {ultraLightCollectionFeatures.map((feature) => (
          <Item key={feature.title} {...feature} />
        ))}
      </div>
      {!!smallPrint && (
        <div className='tw-mx-auto tw-mt-10 tw-text-center tw-text-[11px] tw-italic lg:tw-mt-14 lg:tw-text-[13px]'>
          {smallPrint}
        </div>
      )}
    </div>
  );
};

const Item = ({ icon, title, description }) => {
  return (
    <div className='tw-w-[calc(50%-16px)] tw-max-w-[250px] tw-text-center md:tw-w-auto'>
      <Icon
        url={icon}
        className='tw-mx-auto tw-mb-4 tw-block tw-h-full tw-max-h-11 tw-w-full tw-max-w-[70px]'
        size={70}
        color='#484845'
      />
      <p className='tw-mb-2 tw-text-base tw-font-bold tw-leading-tight md:tw-text-lg'>{title}</p>
      <p className='tw-mb-0 tw-text-sm tw-font-normal tw-leading-tight md:tw-text-base'>{description}</p>
    </div>
  );
};

export default UltraLightCollectionFeatures;
